// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__NlLlS","divider":"Footer_divider__2dz24"};